import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { useApolloClient } from '../../../../api'
import {
  OnVisitorUpdateDocument,
  OnVisitorUpdateSubscription,
} from './OnVisitorUpdate.generated'

export function useVisitorRealTime() {
  const client = useApolloClient()

  useEffect(() => {
    const subscription = client
      .subscribe<OnVisitorUpdateSubscription>({
        query: OnVisitorUpdateDocument,
      })
      .subscribe(({ data }) => {
        Sentry.setUser({
          id: data.OnVisitorUpdate._id,
          email: data.OnVisitorUpdate.email,
          username: data.OnVisitorUpdate.email,
        })

        client.cache.modify({
          fields: {
            Profile(existing = {}) {
              return {
                ...existing,
                visitor: {
                  ...existing.visitor,
                  ...data.OnVisitorUpdate,
                },
              }
            },
          },
        })
      })

    return () => subscription.unsubscribe()
  }, [client])
}
